export const AI_FEATURE_ENABLED = process.env.REACT_APP_AI_ENABLED === "1";

export function resolveAIAvailability(status, requestFailed = false) {
    if (requestFailed) return { available: false, reason: "status_error" };
    if (!status?.enabled) return { available: false, reason: "disabled" };
    if (!status?.available) return { available: false, reason: "provider_unavailable" };
    return { available: true, reason: "ready" };
}

export function chooseAllowedCapability(requested, allowed = []) {
    if (allowed.includes(requested)) return requested;
    if (allowed.includes("general")) return "general";
    return allowed[0] || "";
}
